module.exports = __webpack_public_path__ + "6032c5884a7fc7667322a1c500674cbb.svg";